import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalIntegrationService {

  constructor(private httpClientService: HttpClientService) { }

  async GetByIdExternalIntegration(id:number){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.ExternalIntegration,
      action:"GetByIdExternalItegration"
    },id);
    return await firstValueFrom(observable);
  }

  async getExternalIntegration() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ExternalIntegration
    });
    return await firstValueFrom(observable);
  }

  async createExternalIntegration(username, password, kindId, smtpServer?, smtpPort?, useSSL?, senderEmail?, senderName?) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.ExternalIntegration
    }, {
      UserName: username,
      password: password,
      kindId: kindId,
      SmtpServer: smtpServer,
      SmtpPort: smtpPort,
      UseSSL: useSSL,
      SenderEmail: senderEmail,
      SenderName: senderName
    });
    return await firstValueFrom(observable);
  }

  async updateExternalIntergration(id, username, password, kindId, IsActive, smtpServer?, smtpPort?, useSSL?, senderEmail?, senderName?) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.ExternalIntegration
    }, {
      id: id,
      userName: username,
      password: password,
      kindId: kindId,
      isActive: IsActive,
      smtpServer: smtpServer,
      smtpPort: smtpPort,
      useSSL: useSSL,
      senderEmail: senderEmail,
      senderName: senderName
    });
    return await firstValueFrom(observable);
  }

  async getByIdExternalIntegration(kindId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ExternalIntegration
    }, kindId);
    return await firstValueFrom(observable);
  }
}
